/**
 * ENVIRONMENT: PRODUCTION
 * MODULE: Authentication Redux Action Creators
 * PATH: src/redux/actions/auth.js
 */

import { setCookie, removeCookie } from "utils/cookie";
import { login, getAuthUser, sendLoginOtp, verifyLoginOtp } from "requests/auth";
import {
  GET_AUTH_USER,
  LOGOUT,
  SEND_OTP,
  VERIFY_OTP,
} from "redux/actions/types";

/**
 * Step 1: Validate User ID & Password
 * Does NOT grant dashboard access yet. Triggers SMS OTP.
 */
export const loginAction = (data) => () => {
  return new Promise((resolve, reject) => {
    login(data)
      .then((response) => {
        const payloadData = response.data?.data || response.data || {};
        // DO NOT dispatch LOGIN here - access is only granted after OTP in Step 2!
        resolve(payloadData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * Step 2: Verify 6-Digit OTP & Grant Access
 * Sets the final Bearer token and logs the admin into Redux.
 */
export const verifyOtpAction = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    verifyLoginOtp(data)
      .then((response) => {
        const loginData = response.data?.data || response.data || {};
        const token =
          loginData.access_token ||
          loginData.token ||
          response.data?.token ||
          null;

        if (token) {
          const cookieKey = process.env.REACT_APP_TOKEN_NAME || "token";
          setCookie(cookieKey, token, 1 / 24);
          localStorage.setItem("token", token);
        }

        // Now grant authenticated status in Redux
        dispatch({ type: VERIFY_OTP, payload: loginData });
        resolve(loginData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * Resend OTP Action (Step 2 Countdown)
 */
export const sendOtpAction = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    sendLoginOtp(data)
      .then((response) => {
        const payloadData = response.data?.data || response.data || {};
        dispatch({ type: SEND_OTP, payload: payloadData });
        resolve(payloadData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * Session Verification: Retrieves authenticated administrative user context
 */
export const getAuthUserAction = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem("token");
    if (!token) {
      return reject(new Error("No token found"));
    }

    getAuthUser()
      .then((response) => {
        // Handle common payload structures
        const userData = 
          response.data?.data || 
          response.data?.user || 
          response.data || 
          {};

        // Ensure token remains synchronized
        const activeToken =
          userData.token ||
          userData.access_token ||
          token;

        const cookieKey = process.env.REACT_APP_TOKEN_NAME || "token";
        setCookie(cookieKey, activeToken, 7); // keep cookie active for 7 days
        localStorage.setItem("token", activeToken);

        dispatch({ type: GET_AUTH_USER, payload: userData });
        resolve(userData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * Terminate Session
 */
export const logoutAction = () => (dispatch) => {
  dispatch({ type: LOGOUT });
  const cookieKey = process.env.REACT_APP_TOKEN_NAME || "token";
  removeCookie(cookieKey);
  localStorage.removeItem("token");
  sessionStorage.clear();
};